import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../hooks";

const TOKEN_STORAGE_KEY = "idms_access_token";

const authInitialState: Auth = {
  username: "",
  password: "",
  token: {
    accessToken: "",
    expiresIn: 0,
    refreshToken: "",
    tokenType: "",
    scope: "",
  },
};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<Auth>) => {
      state.username = action.payload.username;
      state.password = action.payload.password;
      state.token = action.payload.token;
      // Persist access token in localStorage
      if (action.payload.token?.accessToken) {
        localStorage.setItem(TOKEN_STORAGE_KEY, action.payload.token.accessToken);
      }
    },
    setToken: (state, action: PayloadAction<Token>) => {
      state.token = action.payload;
      // Update persisted access token in localStorage
      if (action.payload?.accessToken) {
        localStorage.setItem(TOKEN_STORAGE_KEY, action.payload.accessToken);
      }
    },
    logout: () => {
      // Clear persisted access token from localStorage
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return authInitialState;
    },
  },
});

export const { setCredentials, setToken, logout } = authSlice.actions;

export default authSlice.reducer;

export const TOKEN_STORAGE_KEY_EXPORT = TOKEN_STORAGE_KEY;

export const useCurrentAuthenticatedUser = () =>
  useAppSelector((state) => state.auth);
